export default "__VITE_PUBLIC_ASSET__0160a96c__"